"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createAvatarStyle;

function createAvatarStyle(_ref) {
  var avatarBorderRadius = _ref.avatarBorderRadius,
      avatarSize = _ref.avatarSize;
  return {
    '&.webchat__defaultAvatar': {
      borderRadius: avatarBorderRadius,
      height: avatarSize,
      width: avatarSize
    }
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9TdHlsZXMvU3R5bGVTZXQvQXZhdGFyLnRzIl0sIm5hbWVzIjpbImNyZWF0ZUF2YXRhclN0eWxlIiwiYXZhdGFyQm9yZGVyUmFkaXVzIiwiYXZhdGFyU2l6ZSIsImJvcmRlclJhZGl1cyIsImhlaWdodCIsIndpZHRoIl0sIm1hcHBpbmdzIjoiOzs7Ozs7O0FBRWUsU0FBU0EsaUJBQVQsT0FBbUY7QUFBQSxNQUF0REMsa0JBQXNELFFBQXREQSxrQkFBc0Q7QUFBQSxNQUFsQ0MsVUFBa0MsUUFBbENBLFVBQWtDO0FBQ2hHLFNBQU87QUFDTCxnQ0FBNEI7QUFDMUJDLE1BQUFBLFlBQVksRUFBRUYsa0JBRFk7QUFFMUJHLE1BQUFBLE1BQU0sRUFBRUYsVUFGa0I7QUFHMUJHLE1BQUFBLEtBQUssRUFBRUg7QUFIbUI7QUFEdkIsR0FBUDtBQU9EIiwic291cmNlUm9vdCI6ImNvbXBvbmVudDovLy8iLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyBTdHJpY3RTdHlsZU9wdGlvbnMgfSBmcm9tICdib3RmcmFtZXdvcmstd2ViY2hhdC1hcGknO1xuXG5leHBvcnQgZGVmYXVsdCBmdW5jdGlvbiBjcmVhdGVBdmF0YXJTdHlsZSh7IGF2YXRhckJvcmRlclJhZGl1cywgYXZhdGFyU2l6ZSB9OiBTdHJpY3RTdHlsZU9wdGlvbnMpIHtcbiAgcmV0dXJuIHtcbiAgICAnJi53ZWJjaGF0X19kZWZhdWx0QXZhdGFyJzoge1xuICAgICAgYm9yZGVyUmFkaXVzOiBhdmF0YXJCb3JkZXJSYWRpdXMsXG4gICAgICBoZWlnaHQ6IGF2YXRhclNpemUsXG4gICAgICB3aWR0aDogYXZhdGFyU2l6ZVxuICAgIH1cbiAgfTtcbn1cbiJdfQ==